import { HammerModule } from '@angular/platform-browser';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideHttpClient } from '@angular/common/http';
import {
  AUTH_CONFIG,
  AuthService,
  LOGIN_SUCCESS_REDIRECT,
} from '@adminprodigydesign/axis';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
      }),
    ),
    {
      provide: 'AuthService',
      useExisting: AuthService,
    },
    {
      provide: AUTH_CONFIG,
      useValue: {
        apiUrl: '/php/login/function.php',
      },
    },
    {
      provide: LOGIN_SUCCESS_REDIRECT,
      useValue: '/admin/dashboard',
    },

    provideClientHydration(),
    provideHttpClient(),
    importProvidersFrom(HammerModule),
  ],
};
